<template>
  <div class="d-flex justify-center my-6">
    <v-btn @click="$router.push('/user/purchases')" x-large block class="premium-btn-outline px-6 py-7 max-width-button" v-if="purchases.length">
      <div class="d-flex align-center justify-space-between width-100">
        <div class="d-flex align-center">
          <v-icon color="#00B074" class="mr-3">mdi-cash-multiple</v-icon>
          <span class="white--text font-weight-bold">Deine Einkäufe ({{ purchases.length }})</span>
        </div>
        <v-icon color="#00B074">mdi-chevron-right</v-icon>
      </div>
    </v-btn>
  </div>
</template>

<script>
import api from "@/api"

export default {
  data() {
    return {
      purchases: [],
    }
  },
  async created() {
    this.purchases = await api.fetchAllPurchases()
  },
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&display=swap');

.max-width-button {
  max-width: 400px !important;
  width: 100%;
}
.width-100 {
  width: 100%;
}

::v-deep .premium-btn-outline {
  --brand-primary: #00B074;
  background: transparent !important;
  color: var(--brand-primary) !important;
  font-weight: 700 !important;
  border: 1.5px solid rgba(0, 176, 116, 0.4) !important;
  border-radius: 20px !important;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1) !important;
  text-transform: none !important;
  box-shadow: none !important;
}

::v-deep .premium-btn-outline:hover {
  background: rgba(0, 176, 116, 0.06) !important;
  border-color: var(--brand-primary) !important;
  color: var(--brand-primary) !important;
  transform: translateY(-2px) !important;
  box-shadow: 0 0 20px rgba(0, 176, 116, 0.1) !important;
}

::v-deep .v-btn::before {
  background-color: transparent !important;
}
</style>
